if (!customElements.get('scrolling-promotion')) {
  class ScrollingPromotion extends HTMLElement {
    constructor() {
      super();
      if (FoxTheme.config.motionReduced) return;
      this.promotion = this.querySelector('.promotion');
      FoxTheme.Motion.inView(this, this.init.bind(this), { margin: '200px 0px 200px 0px' });
    }
    init() {
      if (this.childElementCount === 1) {
        this.promotion.classList.add('promotion--animated');

        for (let index = 0; index < 10; index++) {
          this.clone = this.promotion.cloneNode(true);
          this.appendChild(this.clone);
        }

        // pause when out of view
        const observer = new IntersectionObserver(
          (entries, _observer) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                this.scrollingPlay();
              } else {
                this.scrollingPause();
              }
            });
          },
          { rootMargin: '0px 0px 50px 0px' }
        );

        observer.observe(this);
      }
    }

    scrollingPlay() {
      this.classList.remove('scrolling-promotion--paused');
    }

    scrollingPause() {
      this.classList.add('scrolling-promotion--paused');
    }
  }
  customElements.define('scrolling-promotion', ScrollingPromotion);
}

// Register the component tooltipe-element 
if (!customElements.get('tooltip-element')) {
  class TooltipElement extends HTMLElement {
    constructor() {
      super();
    }
  
    connectedCallback() {
      this.tooltip = this;
      this.init();
    }
  
    init() {
      this.bindTooltipEvents();
    }
  
    bindTooltipEvents() {
      this.addEventListener('click', this.showTooltip.bind(this));
      this.addEventListener('mouseleave', this.hideTooltip.bind(this));
    }
  
    showTooltip() {
      this.tooltip.classList.add('tooltip--visible');
    }
  
    hideTooltip() {
      this.tooltip.classList.remove('tooltip--visible');
    }
  
    disconnectedCallback() {
      this.removeEventListener('click', this.showTooltip);
      this.removeEventListener('mouseleave', this.hideTooltip);
    }
  }
  customElements.define('tooltip-element', TooltipElement);
}